import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import Select from 'react-select';

const PaymentModal = ({ show, handleClose, onSavePayment, bookings, currentPayment }) => {
    const bookingoption = bookings.map((booking) => ({
        value: booking.id,
        label: `${booking.client?.label} (${booking.checkin?.seconds && booking.checkin.toDate().toLocaleDateString()} 
                 → ${booking.checkout?.seconds && booking.checkout.toDate().toLocaleDateString()}) (${booking?.statut?.label})`
    }));

    const [payment, setPayment] = useState({
        booking: null,
        bookingId: "",
        amount: "",
        type: "",
        method: "",
        date: "", // Ajout du champ date
        reference: "", // Ajout du champ référence
    });

    useEffect(() => { 
        if (currentPayment) {
            const prea = {...currentPayment}
            prea.booking = bookingoption.find((b) => b.value === prea.bookingId);
            console.log('currentPayment', currentPayment.date)
            prea.date = prea.date?.seconds ? prea.date?.toDate().toISOString().split('T')[0] : prea.date?.toISOString().split('T')[0]
            setPayment(prea);
        } else {
            setPayment({ bookingId: "", amount: "", type: "", method: "", reference: "", date: "",  booking: null });
        }
    }, [currentPayment, bookings]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setPayment((prev) => ({ ...prev, [name]: value }));
    };

    const isFormValid = payment.bookingId !== "" && payment.amount !== "" && payment.type !== "" && payment.method !== ""
    && payment.date !== "" && (payment.method !== "Virement" || payment.reference !== ""); // La référence est obligatoire si "Virement"

    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>{currentPayment ? "Modifier le paiement" : "Ajouter un paiement"}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    {/* Sélection de la réservation */}
                    <Form.Group className="mt-2">
                        <Form.Label>Réservation</Form.Label>
                        <Select
                            closeMenuOnSelect={true}
                            required
                            options={bookingoption} 
                            placeholder='Choisir la réservation...'
                            classNamePrefix="react-select"
                            value={payment.booking}
                            onChange={value => {
                                setPayment((prev) => ({ ...prev, ['booking']: value, ['bookingId']: value.value })); 
                            }}
                        /> 
                    </Form.Group>

                    {/* Montant */}
                    <Form.Group className="mt-3">
                        <Form.Label>Montant (€)</Form.Label>
                        <Form.Control
                            type="number"
                            name="amount"
                            value={payment.amount}
                            onChange={e => handleChange(e, e.target.value.replace(',', '.'))}
                            disabled={!payment.bookingId}
                        />
                    </Form.Group>

                    {/* Type de paiement */}
                    <Form.Group className="mt-3">
                        <Form.Label>Type de paiement</Form.Label>
                        <Form.Control
                            as="select"
                            name="type"
                            value={payment.type}
                            onChange={handleChange}
                            disabled={!payment.bookingId}
                        >
                            <option value="">-- Sélectionner --</option>
                            <option value="Acompte">Acompte</option>
                            <option value="Solde">Solde</option>
                            <option value="Caution">Caution</option>
                        </Form.Control>
                    </Form.Group>

                    {/* Méthode de paiement */}
                    <Form.Group className="mt-3">
                        <Form.Label>Méthode</Form.Label>
                        <Form.Control
                            as="select"
                            name="method"
                            value={payment.method}
                            onChange={handleChange}
                            disabled={!payment.bookingId}
                        >
                            <option value="">-- Sélectionner --</option>
                            <option value="Virement">Virement</option>
                            <option value="Carte Bancaire">Carte Bancaire</option>
                            <option value="Espèces">Espèces</option>
                        </Form.Control>
                    </Form.Group>

                    {/* Champ Référence (Affiché uniquement si "Virement" est sélectionné) */}
                    {payment.method === "Virement" && (
                        <Form.Group className="mt-3">
                            <Form.Label>Référence du virement</Form.Label>
                            <Form.Control
                                type="text"
                                name="reference"
                                value={payment.reference}
                                onChange={handleChange}
                            />
                        </Form.Group>
                    )}
                    {/* Date du paiement */}
                    <Form.Group className="mt-3">
                        <Form.Label>Date du paiement</Form.Label>
                        <Form.Control
                            type="date"
                            name="date"
                            value={payment.date}
                            onChange={handleChange}
                            disabled={!payment.bookingId}
                        />
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Annuler
                </Button>
                <Button variant="primary" onClick={() => onSavePayment(payment)} disabled={!isFormValid}>
                    Enregistrer
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default PaymentModal;